export const SocialData = [
  {
    platform: "Github",
    icon: require("../../assets/icons/github.png"),
    link: "https://github.com/khaymanii",
  },
  {
    platform: "Linkedin",
    icon: require("../../assets/icons/linkedin.png"),
    link: "https://www.linkedin.com/in/kenneth-akpo/",
  },
];
